/**
 * Frontend modules bundled in the admin panel — the frontend install list (ARCHITECT §19).
 * Order matters: a module comes after the modules it requires (same rule as config/modules.py).
 * A bundled module's pages/menu only show when the server reports it as installed.
 */

import type { ModuleDefinition } from "@motolynk/app-core";
import { accountsModule } from "@motolynk/module-accounts";
import { auditModule } from "@motolynk/module-audit";
import { bulkuploadModule } from "@motolynk/module-bulkupload";
import { cartModule } from "@motolynk/module-cart";
import { catalogModule } from "@motolynk/module-catalog";
import { cmsModule } from "@motolynk/module-cms";
import { configurationModule } from "@motolynk/module-configuration";
import { coreModule } from "@motolynk/module-core";
import { geoModule } from "@motolynk/module-geo";
import { invoicesModule } from "@motolynk/module-invoices";
import { logisticsModule } from "@motolynk/module-logistics";
import { medialibModule } from "@motolynk/module-medialib";
import { notificationsModule } from "@motolynk/module-notifications";
import { opsModule } from "@motolynk/module-ops";
import { ordersModule } from "@motolynk/module-orders";
import { paymentsModule } from "@motolynk/module-payments";
import { payoutsModule } from "@motolynk/module-payouts";
import { productsModule } from "@motolynk/module-products";
import { returnsModule } from "@motolynk/module-returns";
import { reviewsModule } from "@motolynk/module-reviews";
import { supportModule } from "@motolynk/module-support";
import { reportsModule } from "@motolynk/module-reports";
import { promotionsModule } from "@motolynk/module-promotions";
import { taxesModule } from "@motolynk/module-taxes";
import { vehiclesModule } from "@motolynk/module-vehicles";
import { vendorsModule } from "@motolynk/module-vendors";
import { wishlistModule } from "@motolynk/module-wishlist";

export const modules: ModuleDefinition[] = [
  coreModule,
  geoModule,
  accountsModule,
  configurationModule,
  auditModule,
  opsModule,
  medialibModule,
  notificationsModule,
  vehiclesModule,
  taxesModule,
  catalogModule,
  vendorsModule,
  productsModule,
  logisticsModule,
  cartModule,
  paymentsModule,
  payoutsModule,
  ordersModule,
  invoicesModule,
  returnsModule,
  reviewsModule,
  supportModule,
  reportsModule,
  bulkuploadModule,
  cmsModule,
  promotionsModule,
  wishlistModule,
];
